import { identity } from 'ramda';
import { deepFreeze } from '../redux/ReduxHelpers';

// the transform interface that redux-persist is expecting
export default {
    out: deepFreeze,
    in: identity,
};
